import Deny from './Deny'

export default Deny